import { render, staticRenderFns } from "./AutomationConfigForm.vue?vue&type=template&id=c0328a08"
import script from "./AutomationConfigForm.vue?vue&type=script&lang=ts"
export * from "./AutomationConfigForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports